import { gql } from "@apollo/client";

export const COMPANY_MATCH_FILE_UPLOAD = gql`
  query upload(
    $file: Upload!
    $isPlatformPermissible: Boolean!
    $enforceCountryMatch: Boolean
  ) {
    upload(
      file: $file
      isPlatformPermissible: $isPlatformPermissible
      enforceCountryMatch: $enforceCountryMatch
    ) {
      fileId
      fileName
      uploaded
      lastMatched
      totalChunks
      processedChunks
      totalRows
      isPlatformPermissible
      salesWins
      salesLosses
    }
  }
`;

export const COMPANY_MATCH_FILE_STATS = gql`
  query stats($fileId: Identifier!) {
    stats(fileId: $fileId) {
      fileId
      fileName
      uploaded
      lastMatched
      totalChunks
      processedChunks
      totalRows
      matchedRows
      invalidRows
      salesWins
      salesLosses
      isPlatformPermissible
    }
  }
`;
